import { ICourseOfferingRecommendationTemplateQuery } from '../interfaces/course-offering-recommendation-template.query.interface';
import { CourseOfferingRecommendationItem } from './course-offering-recommendation-item.model';

// @dynamic
export class CourseOfferingRecommendationTemplate {
    id: string;
    components: CourseOfferingRecommendationItem[];
    hasRecommendation: boolean;
    hasValidRecommendation: boolean;

    constructor(query: ICourseOfferingRecommendationTemplateQuery) {
        this.id = query.id.toString();
        this.components = (query.components ?? []).map((c) => new CourseOfferingRecommendationItem(c));
        this.hasRecommendation = query.has_recommendation;
        this.hasValidRecommendation = query.has_valid_recommendation;
    }

    get shouldShowParticipantComponents(): boolean {
        return CourseOfferingRecommendationItem.filterParticipantVisibleComponents(this.components).length > 0;
    }
}
